// api.js - Updated API service

// USING LOCAL HOST FOR DEVELOPMENT
const API_BASE_URL = `${process.env.REACT_APP_BASE_URL || "http://localhost"}:${
  process.env.REACT_APP_BACKEND_PORT || "8000"
}/api`;

export const runPythonScript = async (data) => {
  try {
    const response = await fetch(`${API_BASE_URL}/run-script`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error calling Python script:", error);
    throw error;
  }
};

export const getImages = async () => {
  try {
    const response = await fetch(`${API_BASE_URL}/get_images`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error fetching images:", error);
    throw error;
  }
};

export const gptIdentifyImage = async (images, description) => {
  try {
    const response = await fetch(`${API_BASE_URL}/gpt_identify_image`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        images: images,
        description: description,
      }),
    });

    const result = await response.json();
    return result;
  } catch (error) {
    console.error("Error getting GPT image identification:", error);
    throw error;
  }
};
